// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Work from "./Work.bs.js";
import * as About from "./About.bs.js";
import * as Route from "./Route.bs.js";
import * as React from "react";
import * as Header from "./Header.bs.js";
import * as Reading from "./Reading.bs.js";
import * as Projects from "./Projects.bs.js";
import * as Tailwind from "./Tailwind.bs.js";
import * as Education from "./Education.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/lib/es6/src/Core__Option.bs.js";
import * as Publications from "./Publications.bs.js";
import * as RescriptReactRouter from "@rescript/react/lib/es6/src/RescriptReactRouter.bs.js";
import * as PortraitJpg from "/static/portrait.jpg";

function App(props) {
  var url = RescriptReactRouter.useUrl(undefined, undefined);
  var route = Route.fromString(decodeURI(url.hash));
  var navRef = React.useRef(null);
  var bodyRef = React.useRef(null);
  var headerRef = React.useRef(null);
  React.useEffect(function () {
        var clickHandler = function ($$event) {
          Core__Option.map(Belt_Array.reduce(Belt_Array.map([
                        navRef.current,
                        headerRef.current,
                        bodyRef.current
                      ], (function (prim) {
                          if (prim == null) {
                            return ;
                          } else {
                            return Caml_option.some(prim);
                          }
                        })), undefined, (function (soFar, $$new) {
                      if ($$new !== undefined) {
                        if (soFar !== undefined) {
                          return Belt_Array.concat(soFar, [Caml_option.valFromOption($$new)]);
                        } else {
                          return [Caml_option.valFromOption($$new)];
                        }
                      }
                      
                    })), (function (refs) {
                  if (!Belt_Array.some(Belt_Array.map(refs, (function (ref) {
                                return ref.contains($$event.target);
                              })), (function (b) {
                            return b;
                          }))) {
                    return RescriptReactRouter.push("#" + Route.toString(/* Home */7) + "");
                  }
                  
                }));
        };
        var evt = "mousedown";
        document.addEventListener(evt, clickHandler);
        return (function (param) {
                  removeEventListener(evt, clickHandler);
                });
      });
  var tmp;
  var exit = 0;
  switch (route) {
    case /* About */0 :
        tmp = React.createElement(Header.make, {
              inputRef: headerRef,
              children: "About Ethan"
            });
        break;
    case /* Publications */1 :
    case /* Projects */2 :
    case /* Education */3 :
    case /* WorkExperience */4 :
    case /* Reading */5 :
        exit = 1;
        break;
    case /* Invalid */6 :
        tmp = React.createElement(Header.make, {
              inputRef: headerRef,
              children: "Page not found."
            });
        break;
    case /* Home */7 :
        tmp = React.createElement("h1", {
              className: "text-xl sm:text-2xl tracking-tight sm:py-10 2xl:py-8 3xl:flex 3xl:flex-row 3xl:flex-1 3xl:justify-between"
            }, React.createElement("p", {
                  className: "block"
                }, "Ethan A. Brooks"), React.createElement("p", {
                  className: "block text-gray-700"
                }, "Researcher"), React.createElement("p", {
                  className: "block text-gray-700"
                }, "Reinforcement Learning"), React.createElement("p", {
                  className: "block text-gray-700"
                }, "Foundation Models"));
        break;
    
  }
  if (exit === 1) {
    tmp = React.createElement(Header.make, {
          inputRef: headerRef,
          children: Route.toString(route)
        });
  }
  var tmp$1;
  switch (route) {
    case /* About */0 :
        tmp$1 = React.createElement(About.make, {
              inputRef: bodyRef
            });
        break;
    case /* Publications */1 :
        tmp$1 = React.createElement(Publications.make, {
              inputRef: bodyRef
            });
        break;
    case /* Projects */2 :
        tmp$1 = React.createElement(Projects.make, {
              inputRef: bodyRef
            });
        break;
    case /* Education */3 :
        tmp$1 = React.createElement(Education.make, {
              inputRef: bodyRef
            });
        break;
    case /* WorkExperience */4 :
        tmp$1 = React.createElement(Work.make, {
              inputRef: bodyRef
            });
        break;
    case /* Reading */5 :
        tmp$1 = React.createElement(Reading.make, {
              inputRef: bodyRef
            });
        break;
    case /* Invalid */6 :
    case /* Home */7 :
        tmp$1 = React.createElement(React.Fragment, undefined);
        break;
    
  }
  return React.createElement("div", {
              className: "w-screen h-screen bg-top bg-cover",
              style: {
                backgroundImage: "url(" + PortraitJpg + ")"
              }
            }, React.createElement("div", {
                  className: "flex flex-col p-10 sm:w-3/5 xl:w-1/2 3xl:w-1/3 h-screen"
                }, React.createElement("nav", {
                      ref: Caml_option.some(navRef),
                      className: "\n        flex flex-col \n        sm:grid sm:grid-rows-2 sm:grid-flow-col sm:gap-x-14\n        lg:flex lg:flex-row lg:flex-wrap lg:justify-between lg:gap-x-4\n        "
                    }, Belt_Array.mapWithIndex(Belt_Array.keep(Route.array, (function (r) {
                                return r !== /* Home */7;
                              })), (function (i, r) {
                            return React.createElement("a", {
                                        key: i.toString(),
                                        ref: Caml_option.some(navRef),
                                        className: r === route ? Tailwind.activeClassName : Tailwind.inactiveClassName,
                                        href: "#" + encodeURI(Route.toString(r)) + ""
                                      }, Route.toString(r));
                          }))), React.createElement("div", {
                      className: route === /* Home */7 ? "" : "flex flex-row justify-between flex-grow  items-center"
                    }, React.createElement("div", {
                          className: route === /* Home */7 ? "" : "bg-white ring-black border border-gray-300 rounded-md"
                        }, tmp, React.createElement("div", undefined, tmp$1)))));
}

var $$Array;

var make = App;

export {
  $$Array ,
  make ,
}
/* Work Not a pure module */
